module.exports = __webpack_public_path__ + "img/icon84.15157521.png";